export default __webpack_public_path__ + "static/media/3h.69b57337.png";